import React from 'react';
import { Status, StatusProps } from '@fiverr-private/data_display';
import { Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { BriefDisplayStatus } from '../../types';

interface StatusTagProps {
  type?: StatusProps['type'];
  children: React.ReactNode;
}

const StatusTag = ({ type, children }: StatusTagProps) => (
  <Status type={type}>
    <Typography whiteSpace="nowrap" size="b_xxs" fontWeight="bold">
      {children}
    </Typography>
  </Status>
);

const i18nPrefix = 'dynamic_matching.brief_status_tag';

interface BriefStatusTagProps {
  status: BriefDisplayStatus;
}

export const BriefStatusTag = ({ status }: BriefStatusTagProps) => {
  switch (status) {
    case BriefDisplayStatus.NO_INVITES_SENT:
      return (
        <StatusTag type="warning">
          <I18n k={`${i18nPrefix}.no_invites_sent`} />
        </StatusTag>
      );
    case BriefDisplayStatus.LIVE:
      return (
        <StatusTag type="info">
          <I18n k={`${i18nPrefix}.live`} />
        </StatusTag>
      );
    case BriefDisplayStatus.HIRED:
      return (
        <StatusTag type="success">
          <I18n k={`${i18nPrefix}.hired`} />
        </StatusTag>
      );
    case BriefDisplayStatus.INACTIVE:
      return (
        <StatusTag>
          <I18n k={`${i18nPrefix}.inactive`} />
        </StatusTag>
      );
    case BriefDisplayStatus.DELETED:
      return (
        <StatusTag>
          <I18n k={`${i18nPrefix}.deleted`} />
        </StatusTag>
      );
    case BriefDisplayStatus.REJECTED:
      return (
        <StatusTag type="error">
          <I18n k={`${i18nPrefix}.rejected`} />
        </StatusTag>
      );
    case BriefDisplayStatus.DONE:
      return (
        <StatusTag type="success">
          <I18n k={`${i18nPrefix}.done`} />
        </StatusTag>
      );
    case BriefDisplayStatus.UNKNOWN:
    default:
      return null;
  }
};
